import React from 'react';
import { ColorPropsEnum } from '../../types';
export var IconBenefitsCard = _ref => {
  var {
    size,
    strokeWidth = 1.5,
    color = ColorPropsEnum.black
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.8 9.7L5.27096 7.69595C4.98196 6.62695 5.61696 5.52795 6.68696 5.24295L16.73 2.56695C17.79 2.28495 18.89 2.91996 19.176 3.97896L20.93 10.488C21.218 11.557 20.582 12.656 19.514 12.941L17.4 13.504",
    strokeWidth: strokeWidth,
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.4999H5C3.896 20.4999 3 19.6049 3 18.4999V11.7629C3 10.6579 3.895 9.76294 5 9.76294H15.4C16.505 9.76294 17.4 10.6579 17.4 11.7629V15.1314",
    strokeWidth: strokeWidth,
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9036 17.8015L14.1523 19.5528L13.1016 18.502",
    strokeWidth: strokeWidth,
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2478 19.2343L10.8457 20.0168L10.9754 20.9901C11.0474 21.5304 11.4715 21.9554 12.0117 22.0274L12.9878 22.158L13.7693 22.7558C14.2015 23.0863 14.8021 23.0863 15.2343 22.7558L16.0168 22.158H16.0159L16.9901 22.0283C17.5304 21.9563 17.9554 21.5322 18.0274 20.9919L18.158 20.0159C18.158 20.0168 18.4605 19.6206 18.7558 19.2343C19.0863 18.8021 19.0863 18.2015 18.7558 17.7693L18.158 16.9869L18.0283 16.0135C17.9563 15.4733 17.5322 15.0483 16.9919 14.9763L16.0159 14.8457L15.2343 14.2478C14.8021 13.9174 14.2015 13.9174 13.7693 14.2478L12.9869 14.8457H12.9878L12.0135 14.9754C11.4733 15.0474 11.0483 15.4715 10.9763 16.0117L10.8457 16.9878C10.8457 16.9869 10.5432 17.3831 10.2478 17.7693C9.91739 18.2015 9.91739 18.8012 10.2478 19.2343Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeWidth: strokeWidth,
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
//# sourceMappingURL=IconBenefitsCard.js.map